import { object, string, mixed, number, reach, boolean } from "yup";

export const retirementVehicles = Object.freeze({
    afore: "afore",
    fondo_de_inversion: "fondoDeInversion",
    ppr: "ppr",
})

export const resultTypes = Object.freeze({
    FULLSCREEN: "fullscreen",  
    STICKY: "sticky",  
})

export const phoneNumber = '+16172319290';
export const callNumber = '8125891089';
export const fancyPhoneNumber = '81-2589-1089';

export const prepopulatedRetirementPlannerForm = {
    file: {
      value: '',
      status: 'neutral',
      error: '',
      validation: mixed().test('fileType', "Debes adjuntar un documento que tenga la extensión .pdf", value => value && value.includes('.pdf'))
    },
    user_email: {
      value: 'emiliogzz24@gmail.com',
      status: 'neutral',
      error: '',
      validation: string().required("El correo del cliente es un campo requerido").email("Debe ser un correo electrónico válido"),
    },
    advisor_email: {
      value: 'emilio@finauta.com',
      status: 'neutral',
      error: '',
      validation: string().required("El correo del asesor es un campo requerido").email("Debe ser un correo electrónico válido"),
    },
    underage_children_num: {
      value: 1,
      status: 'neutral',
      error: '',
      validation: number().min(0,"La cantidad de hij@s menores de edad en el retiro debe ser mayor que o igual a 0").required("La cantidad de hij@s mejores de edad en el retiro es requerida").transform(value => (isNaN(value) ? undefined : value)),
    },
    civil_status: {
      value: 'Casado',
      status: 'neutral',
      error: '',
      validation: string().required("El estado civil es un campo requerido"),
    },
    alive_parents_num: {
      value: '',
      status: 'neutral',
      error: '',
      validation: number().min(0, "La cantidad de padres vivos debe ser mayor que o igual a 0").transform(value => (isNaN(value) ? undefined : value)),
    },
    extra_weeks: {
      value: '',
      status: 'neutral',
      error: '',
      validation: number().positive("La cantidad de semanas extra debe ser mayor que 0").transform(value => (isNaN(value) ? undefined : value)),
    },
    reactivation_wage: {
      value: '',
      status: 'neutral',
      error: '',
      validation: number().positive("El salario de reactivación debe ser mayor que 0").transform(value => (isNaN(value) ? undefined : value)),
    },
    edge_case: {
      value: false,
      status: 'neutral',
      error: '',
      validation: boolean(),
    },
    mod_40_scenarios: [{
        value: '123',
        status: 'neutral',
        error: '',
        validation: number("No puede estar vacío").transform(value => (isNaN(value) ? undefined : value)).positive("Debe ser mayor que 0").required("Todos los escenarios son campos requeridos"),
      },{
        value: '345',
        status: 'neutral',
        error: '',
        validation: number("No puede estar vacío").transform(value => (isNaN(value) ? undefined : value)).positive("Debe ser mayor que 0").required("Todos los escenarios son campos requeridos"),
      }],
  };
export const TWILIO_API_URL = 'https://us-central1-finauta-twilio.cloudfunctions.net/finauta_twilio';

export const PENSION_PLAN_PRICE = 750;
export const DISCOUNTED_PENSION_PLAN_PRICE = 600;
export const OPTIMUM_AGE_ANALISIS_PRICE = 500;